import { Directive, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
    selector: "[trim]",
})
export class TrimDirective {
    constructor(private control: NgControl) {}

    @HostListener("input", ["$event"])
    onInput(event: any) {
        const input = event.target;
        const value = input.value;

        const cleanedValue = value.trim();

        if (value !== cleanedValue) {
            // Update value
            this.control.control?.setValue(cleanedValue, { emitEvent: false });

            // 🔥 Force cursor to end
            requestAnimationFrame(() => {
                const len = cleanedValue.length;
                input.setSelectionRange(len, len);
            });
        }
    }
}
